module.exports = __webpack_public_path__ + "img/b0a3de0.png";